import type { ClientIntegration } from '../index'
import { figmaApi, figmaStatusOf } from './api'
import { FigmaSettingsCard } from './SettingsCard'
import { FigmaImportSection } from './FigmaImport'
import { FigmaLogo, FigmaTile } from './Tile'

/** Everything the pages need to know about Figma — its one line in
 *  `src/integrations/index.tsx` mounts all of it. */
export const figmaIntegration: ClientIntegration = {
  id: 'figma',
  name: 'Figma',
  Tile: FigmaTile,
  importSource: {
    title: 'Figma file',
    blurb: 'Paste a file link. Frames stay editable.',
    icon: <FigmaLogo width={15} height={22} />,
  },
  automationPull: {
    blurb: 'Import what’s new in a Figma file onto a canvas.',
    subtitle: 'Frames',
    placeholder: 'https://www.figma.com/design/…',
    field: 'url',
  },
  disconnectCopy: 'hosted.figmaDisconnectCopy',
  isConnected: (status) => figmaStatusOf(status).connected,
  disconnect: figmaApi.disconnect,
  SettingsCard: FigmaSettingsCard,
  ImportSection: FigmaImportSection,
}
